// import { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import ResumePreview from "./ResumePreview";
// import axios from "axios";
// import { data } from "autoprefixer";

// export default function ResumeEditor() {
//   const [searchParams] = useSearchParams();
//   const templateId = searchParams.get("template") || "1";

//   const [resumeData, setResumeData] = useState(null);

//   useEffect(() => {
//     fetchResume();
//   }, []);

//   const fetchResume = async () => {
//     try {
//       const res = await axios.get("/api/resume/my", {
//         withCredentials: true,
//       });

//       if (res.data?.resume) {
//         setResumeData(res.data.resume.resumeData);
//       } else {
//         setResumeData({});
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   if (!resumeData) return <div>Loading...</div>;
// console.log("RESUME DATA:", resumeData);

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <div className="max-w-6xl mx-auto bg-white shadow rounded-lg">
//         <ResumePreview
//           templateId={templateId}
//           resumeData={resumeData}
//         />
//       </div>
//     </div>
//   );
// }




import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResumePreview from "./ResumePreview";
import axios from "axios";

export default function ResumeEditor() {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get("template") || "1";

  const [resumeData, setResumeData] = useState(null);
  const [editableData, setEditableData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchResume();
  }, []);

  const fetchResume = async () => {
    try {
      const res = await axios.get("/api/resume/my", {
        withCredentials: true,
      });
      console.log(res.data);
      if (res.data?.resume?.resumeData) {
        setResumeData(res.data.resume.resumeData);
        setEditableData(res.data.resume.resumeData);
      } else {
        const defaultData = {
          personalInfo: {
            firstName: "DAVID",
            lastName: "WILLIAMS",
            city: "Austin, TX 78704",
            phone: "(555)555-5555",
            email: "david@example.com",
          },
          summary:
            "Experienced Executive Secretary with 19 years enhancing operational efficiency and team collaboration. Proven record in administrative management, event coordination, and budget oversight.",
          experience: [
            {
              title: "Executive Secretary",
              startDate: "01/2019",
              endDate: "12/2025",
              company: "Peak Business Solutions",
              location: "Austin, TX",
              responsibilities: [
                "Managed executive schedules, improved efficiency 25%",
                "Led admin team, reduced operational costs by 15%",
                "Coordinated events, increased attendance by 40%",
              ],
            },
          ],
          skills: [
            { name: "Calendar management", level: 4 },
            { name: "Time management", level: 4 },
            { name: "Office administration", level: 4 },
          ],
          education: [
            {
              degree: "Master of Business Administration",
              year: "06/2005",
              university: "Harvard University – Pinehill, TX",
            },
          ],
        };

        setResumeData(defaultData);
        setEditableData(defaultData);
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (!resumeData) return <div>Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-6 mt-24 " >
      <div className="w-full">

      
        <ResumePreview
          templateId={templateId}
          data={isEditing ? editableData : resumeData}
          isEditing={isEditing}
          setEditableData={setEditableData}
        />
      </div>
    </div>
  );
}


